import React from 'react'

const pageBenefitBlocks = ({ slice }) => {

    return (
        <section className="page-benefit-blocks">
            <div className="container">
                <div className="benefit-blocks-two">
                    <div className="benefit-blocks-blue">
                        <div className="benefit-blocks-icon">
                            <img src={slice.primary.benefit_one_icon.url} alt={slice.primary.benefit_one_icon.alt} />
                        </div>
                        <div className="benefit-blocks-header">{slice.primary.benefit_one_header.text}</div>
                        <div className="benefit-blocks-text">{slice.primary.benefit_one_text.text}</div>
                    </div>
                    <div className="benefit-blocks-brown">
                        <div className="benefit-blocks-icon">
                            <img src={slice.primary.benefit_two_icon.url} alt={slice.primary.benefit_two_icon.alt} />
                        </div>
                        <div className="benefit-blocks-header">{slice.primary.benefit_two_header.text}</div>
                        <div className="benefit-blocks-text">{slice.primary.benefit_two_text.text}</div>
                    </div>
                </div>
                <div className="benefit-blocks-three">
                     <div className="benefit-blocks-brown">
                        <div className="benefit-blocks-icon">
                            <img src={slice.primary.benefit_three_icon.url} alt={slice.primary.benefit_three_icon.alt} />
                        </div>
                        <div className="benefit-blocks-header">{slice.primary.benefit_three_header.text}</div>
                        <div className="benefit-blocks-text">{slice.primary.benefit_three_text.text}</div>
                    </div>
                    <div className="benefit-blocks-blue">
                        <div className="benefit-blocks-icon">
                            <img src={slice.primary.benefit_four_icon.url} alt={slice.primary.benefit_four_icon.alt} />
                        </div>
                        <div className="benefit-blocks-header">{slice.primary.benefit_four_header.text}</div>
                        <div className="benefit-blocks-text">{slice.primary.benefit_four_text.text}</div>
                    </div>
                     <div className="benefit-blocks-white">
                        <div className="benefit-blocks-icon">
                            <img src={slice.primary.benefit_five_icon.url} alt={slice.primary.benefit_five_icon.alt} />
                        </div>
                        <div className="benefit-blocks-header">{slice.primary.benefit_five_header.text}</div>
                        <div className="benefit-blocks-text">{slice.primary.benefit_five_text.text}</div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default pageBenefitBlocks